module.exports = new __parcel__URL__("lock.bb0ac3af.svg").toString();